import * as React from 'react';
import DisplayLongDescriptionAndVariantMFRName
    from "../../../../component/Product/DisplayLongDescriptionAndVariantMFRName";
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';

const ListingBeforeAddToCart = (props) => {
    const {PRODUCTS_DATA,getProductInventoryQuantityByERPPartNumber,getProductInventoryLeadTimeByERPPartNumber} = props;

    return (
        <>
            <table className="table table-outline rounded-0">
                <thead className="bg-light">
                    <tr>
                        <th className="border-0 text-none font-12">Product(s)</th>
                        <th className="border-0 text-none font-12">Requested Quantity</th>
                        <th className="border-0 text-none font-12">Backorder Quantity</th>
                    </tr>
                </thead>
                <tbody className="border-top-0">
                    {
                        Object.entries(PRODUCTS_DATA).length > 0 &&
                        PRODUCTS_DATA.map((v, i) => (
                            <React.Fragment key={v.ItemNumber}>
                                <tr>
                                    <td className="align-middle">
                                        <div className="inventory-product-info">
                                            <div className="inventory-product-name">
                                                <NavigateToPDP data={{
                                                    ManufacturerName: v?.ManufacturerName,
                                                    ERPMFRPartNumber: v?.ERPMFRPartNumber,
                                                    ItemNumber: v?.ItemNumber,
                                                }}>
                                                    <b className='text-black'>{v.ERPMFRPartNumber}</b>
                                                </NavigateToPDP>
                                            </div>
                                            <div className="inventory-product-by">
                                                <DisplayLongDescriptionAndVariantMFRName
                                                    currentProduct={v} inventory_alert_popup={true}/>
                                            </div>
                                            <div className="inventory-product-stock"><b>In
                                                Stock: {getProductInventoryQuantityByERPPartNumber(v.ERPPartNumber || v.partNumber)}</b>
                                            </div>
                                            <div className="inventory-product-lead">Lead Time From
                                                Supplier: {getProductInventoryLeadTimeByERPPartNumber(v.ERPPartNumber || v.partNumber)}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="align-middle">
                                        <span>{v.totalQuantity}</span>
                                    </td>
                                    <td className="align-middle">
                                        <span>{v.backOrderQuantity}</span>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))
                    }
                </tbody>
            </table>
        </>
    );
}

export default ListingBeforeAddToCart;